import React from 'react';
import { usePagination, DOTS } from '../hooks/usePagination';
import { Button } from 'reactstrap';

const TablePagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1];
  const buttonStyle = { marginRight: 1, marginLeft: 1, paddingTop: 0, paddingBottom: 0, backgroundColor: '#AAAAAA', color: 'white', border: 0};
  return (
    <div className='d-flex'>
      <Button
        size="sm"
        outline
        style={buttonStyle}
        disabled={currentPage === 1} 
        onClick={() => onPageChange(1)}
      >
        « First
      </Button>
      <Button
        style={buttonStyle}
        size="sm"
        outline
        disabled={currentPage === 1}
        onClick={onPrevious}
      >
        ‹ Prev
      </Button>
      {paginationRange.map(pageNumber => {
          if (pageNumber === DOTS) {
            return <div style={{padding: 8, paddingBottom: 0}}>&#8230;</div>;
          }

          const isCurrent = pageNumber === currentPage
          return (
            <Button
              outline
              size='sm'
              style={buttonStyle}
              type='text'
              disabled={isCurrent}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </Button>
          );
        })}
      <Button
        outline
        size="sm"
        disabled={lastPage === currentPage}
        onClick={onNext}
        style={buttonStyle}
      >
        Next ›
      </Button>
      <Button
        size="sm"
        outline
        disabled={lastPage === currentPage}
        onClick={() => onPageChange(lastPage)}
        style={buttonStyle}
      >
        Last »
      </Button>
    </div>
  );
};

export default TablePagination;
